import React from 'react'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { Kategorija } from 'pages'
import { connect } from 'react-redux'
import loadingStatuss from 'actions/LoadingActions'

const QUERY = gql`
  query PageLiepajniekiemQuery($lang: String!, $liepajniekiem: [Int]!) {
    page(lang: $lang, _id: $liepajniekiem) {
      title
      images {
        alt
        src
        thumb(size: "card-default") {
          url
          retina
          width
          height
        }
      }
      path
      acf
      rewrite_url
      rewrite_source
      rewrite_target
    }
    noderigi(lang: $lang) {
      nosaukums
      ikona
      post {
        path
        rewrite_url
        rewrite_source
        rewrite_target
      }
    }
    jaunumi(lang: $lang, perpage: 6, page: 0) {
      posts {
        path
        title
        date_created
      }
    }
    jaunumiLapa: page(lang: $lang, _id: 1516) {
      path
    }
    teksti(lang: $lang, _id:[
      "liepajniekiem",
      "noderigi",
      "jaunumi",
      "skatit_vairak_jaunumus"
    ]) {
      _id
      text
    }
  }
`

const queryOptions = {
  options: ({ lang, init_page }) => ({
    fetchPolicy: 'cache-first',
    variables: {
      lang: (lang || 'lv'),
      liepajniekiem: init_page.relationship,
      banner: init_page.images&&init_page.images[0]?init_page.images[0]:{}
    }
  }),
  props: props => {
    const { data: {
      loading,
      page,
      variables: { banner },
      noderigi,
      jaunumi,
      jaunumiLapa,
      teksti,
      ...rest
    }} = props;

    return {
      loading,
      data: {
        id: 'liepajniekiem',
        page,
        banner,
        noderigi,
        jaunumi,
        jaunumiLapa,
        teksti,
      }
    }
  }
}
class PageLiepajniekiem extends React.PureComponent {
  
  componentWillMount() {
    if(this.props.loading){
        this.props.loadingStatuss({_id:this.props.path+'__',loading:true})  
    } else if(!this.props.loading && this.props.global_loading && this.props.global_loading[this.props.path+'__']===true){
        this.props.loadingStatuss({_id:this.props.path+'__',loading:false})    
    }
  }
  
  componentWillReceiveProps(nextProps) {
     if(nextProps.loading && nextProps.global_loading[nextProps.path+'__']===false){
        nextProps.loadingStatuss({_id:nextProps.path+'__',loading:true})  
     } else if(!nextProps.loading && nextProps.global_loading[nextProps.path+'__']===true){
        nextProps.loadingStatuss({_id:nextProps.path+'__',loading:false})    
     }
  }

 render() {
      const props = this.props
      if(props.loading){
        return null
      }
      if(props.error){
        console.error(props.error.message)
      }
      return  <Kategorija data={props.data} lang={props.lang} />
  }
}

const mapStateToProps = state => {
  // console.log(state)
  return ({
    global_loading: state.global_loading,
  })
}
const mapDispatchToProps = dispatch => ({
  loadingStatuss: LOADING => {
    dispatch(loadingStatuss(LOADING))
  }
})



export default compose(
  graphql(QUERY, queryOptions),
  connect(mapStateToProps, mapDispatchToProps)
)(PageLiepajniekiem)



// WEBPACK FOOTER //
// ./src/components/PageLiepajniekiem.js